import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { lightOrDark } from "@app/embedded/theme/utils";

export const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryReg,
  color: lightOrDark(
    theme.palette.shades.neutral[700],
    theme.palette.shades.neutral[300]
  )(theme),
  fontFamily: theme.typography.fontFamilySecondary,
}));

export const Banner = styled(Alert)({
  alignItems: "center",
  width: "100%",
  border: "none",
  borderRadius: "0px",
  padding: "12px 16px",
  flexShrink: 0,
  "& .MuiAlert-action": {
    flexShrink: 0,
    marginRight: "0px",
    alignSelf: "initial",
  },
  "&.column": {
    alignItems: "flex-start",
    "& .MuiAlert-message": {
      paddingTop: "3px", // slight offset so the text aligns horizontally with the icon
    },
  },
});

export const AlertBannerAction = styled(Button)(({ theme, variant }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 600,
  ...(variant === "contained" && {
    padding: theme.spacing(1, 1.5),
  }),
}));
